var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-container-inline d-flex flex-column overflow-hidden",style:({ height: _vm.heightOverride })},[_c('CubeSpin',{staticClass:"inline-spinner",attrs:{"size":"60"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }